import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RisrAiUsageHostComponent } from './risr-ai-usage-host.component';

/**
 * Page-like wrapper around {@link RisrAiUsageHostComponent}, used by the
 * `/settings/ai-usage` route (linked from the settings menu). Adds page chrome
 * (heading + container) around the framework-agnostic `<risr-ai-usage>` panel.
 *
 * Access is gated in the UI by the settings menu (org admins) and enforced by
 * the backend via the `risrai:usage:stats` scope. When the current org has no
 * `risrai` backend URL configured the host renders nothing.
 */
@Component({
    selector: 'risr-ai-usage-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RisrAiUsageHostComponent],
    template: `
        <div class="container-fluid" style="padding: 20px">
            <h1 i18n="@@aiUsagePageTitle">AI usage</h1>
            <p i18n="@@aiUsagePageIntro" class="text-muted">
                Token usage and estimated cost for AI Assistant across your
                organisation.
            </p>
            <risr-ai-usage-host></risr-ai-usage-host>
        </div>
    `,
})
export class RisrAiUsagePageComponent {}
